const channelsInfo = [
  { "social skills": "UCom1IdOkCHvzkOjbmck2gfg" },
  { strength: "UCftagEsyzmVwwKZyaFtNgBA" },
  { intelligence: "UCFwsYHhZbudaV4No59q6mbQ" },
];

const socialSkillsChannel = [
  {
    _id: "UCom1IdOkCHvzkOjbmck2gfg",
    categoryName: "social skills",
  },
];

const strengthChannel = [
  {
    _id: "UCftagEsyzmVwwKZyaFtNgBA",
    categoryName: "strength",
  },
];

const intelligenceChannel = [
  {
    _id: "UCFwsYHhZbudaV4No59q6mbQ",
    categoryName: "intelligence",
  },
];

const categories = [
  {
    chipText: "All",
    chipPreviewText: "All",
  },
  {
    chipText: "BowTiedBull",
    chipPreviewText: "Intelligence",
  },
  {
    chipText: "Armani Talks",
    chipPreviewText: "Social Skills",
  },
  {
    chipText: "Bodyweight Muscle",
    chipPreviewText: "Strength",
  },
];

export {
  channelsInfo,
  socialSkillsChannel,
  strengthChannel,
  intelligenceChannel,
  categories
};
